import React from 'react'
import { PreviewPageWrapper } from './HomePreviewPageStyled'
import { VIEW_MODE } from '../../constant'
import { HomePageContent } from '../../components/HomePageContent'
import LandingHeader from '../../components/LandingHeader'
import LandingBody from '../../components/LandingBody'
import LandingFooterBig from '../../components/LandingFooterBig'
import { useRecoilValue } from 'recoil'
import { pageConfigDraftState } from '../../recoil/landingPageState'

const HomePreviewPage = props => {
  const pageConfigDraft = useRecoilValue(pageConfigDraftState)
  return (
    <>
      <LandingHeader mode={VIEW_MODE.PREVIEW} data={pageConfigDraft} />
      <LandingBody>
        <PreviewPageWrapper>
          <HomePageContent mode={VIEW_MODE.PREVIEW} data={pageConfigDraft} />
        </PreviewPageWrapper>
      </LandingBody>
      <LandingFooterBig data={pageConfigDraft} mode={VIEW_MODE.PREVIEW} />
    </>
  )
}

HomePreviewPage.propTypes = {}

export default HomePreviewPage
